import { defineComponent as _defineComponent } from 'vue'
import { InputField } from '@/ui/components/form/InputField';
  import { PaginationResetCallback } from '@/ui/types';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilter',
  props: {
    value: {
      type: String,
      default: '',
    },
    reset: {
      type: Function as () => PaginationResetCallback,
      default: () => {},
    },
  },
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const onInput = (value: string) => {
    props.reset();
    emit('input', value);
  };

return { __sfc: true,props, emit, onInput, InputField }
}

})